import React, { FC, useEffect } from 'react';
import { AnalyticsSenderProvider, useAnalytics } from '@funtech-int/yango-shared';

import { Error } from '@/shared/components/Error/Error';

import { createAnalyticsEvents } from '../../lib/createAnalyticsEvents';
import { SelectionNotFoundError } from '../../lib/error';

interface SelectionErrorProps {
    error: SelectionNotFoundError;
}

const SelectionErrorComponent: FC<SelectionErrorProps> = ({ error }) => {
    const analytics = useAnalytics(createAnalyticsEvents);

    useEffect(() => {
        analytics.error(error.key);
    }, [analytics, error.key]);

    return <Error />;
};

export const SelectionError: FC<SelectionErrorProps> = ({ error }) => (
    <AnalyticsSenderProvider>
        <SelectionErrorComponent error={error} />
    </AnalyticsSenderProvider>
);
